import { IDataSourceError } from './IDataSourceError';

export interface IDataSourceErrorMessage extends IDataSourceError {
    message: string;
}


